import { IWidget } from 'common/schema/widget/Widget';
import { useRequestCompileContext } from '../../requests/compile-context/RequestCompileContext';
import { useFormikFieldChange } from 'client/ui/form/hooks/useFormikFieldChange';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { WidgetInputConditional } from 'common/schema/widget/input/WidgetInputConditional';
import { WidgetLogic } from 'common/schema/widget/WidgetLogic';
import { WidgetInputViewType } from 'common/schema/widget/input/WidgetInputViewType';
import { metadataSuffix, SuffixType } from '../../widget/helper/metadataSuffix';
import { MetadataConditionalLogic } from 'common/schema/metadata/conditional/MetadataConditionalLogic';

/**
 * Hook per aggiornare la visualizzazione di un Widget
 * in base ai valori impostati in un altro Widget
 *
 * Aggiorna anche il Form eliminando i valori dei campi nascosti
 */
export function useConditionalFormWidget(widget: IWidget) {
  // verifica della visualizzazione consizionale del widget
  // prendiamo i valori correnti del form
  const { request } = useRequestCompileContext();
  // prendiamo le condizioni del widget
  const condition = WidgetLogic.getCondition(widget);

  // valutiamo se cambia il metadato nel form
  useFormikFieldChange(
    (formik, [conditionalValue]) => {
      // quando il campo viene nascosto
      if (!isConditionVerified(condition, conditionalValue)) {
        const metadatas = MetadataLogic.fromWidget(widget);

        // azzeriamo tutti i campi (metadati) del widget
        metadatas.forEach(metadata => {
          formik.setFieldValue(`values.${metadata.id}`, undefined);
          // gestiamo eccezione conferma email che ha un ID non registrato nel widget
          if (widget.input?.view == WidgetInputViewType.EmailCheck) {
            formik.setFieldValue(
              `values.${metadataSuffix(metadata.id, SuffixType.Confirm)}`,
              undefined
            );
          }
        });
      }
    },
    [condition.metadataId ? `values.${condition.metadataId}` : undefined]
  );

  // se non esiste una condizione di visualizzazione mostriamo il campo
  if (!condition.metadataId) return { visible: true };

  // altrimenti controlliamo la condizione per mostrare o no il campo
  const conditionValue = request.values[condition.metadataId] as string;
  return {
    visible: isConditionVerified(condition, conditionValue)
  };
}

function isConditionVerified(
  condition: WidgetInputConditional,
  conditionalValue: string
) {
  return MetadataConditionalLogic.isVerified(condition, conditionalValue);
}
